import commonReducer from "./common/reducer";

export default {
    commonReducer
}